var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6973 10.0003L16.8255 4.87209L17.883 3.81456C18.039 3.65855 18.039 3.40504 17.883 3.24904L16.7515 2.1175C16.5955 1.9615 16.3419 1.9615 16.1859 2.1175L10.0003 8.3032L3.81456 2.117C3.65855 1.961 3.40504 1.961 3.24904 2.117L2.117 3.24854C1.961 3.40454 1.961 3.65805 2.117 3.81406L8.3032 10.0003L2.117 16.1859C1.961 16.3419 1.961 16.5955 2.117 16.7515L3.24854 17.883C3.40454 18.039 3.65805 18.039 3.81406 17.883L10.0003 11.6973L15.1284 16.8255L16.1859 17.883C16.3419 18.039 16.5955 18.039 16.7515 17.883L17.883 16.7515C18.039 16.5955 18.039 16.3419 17.883 16.1859L11.6973 10.0003Z",
    fill: "#D93A4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x_icon.faf98a079f917a0ce9d4c68293151002.svg";
export { ForwardRef as ReactComponent };